<template>
  <div
    id="crumbs"
    @mouseenter="openPresetMenu"
    @mouseleave="closePresetMenu"
    :class="{ 'crumbs-rf-agent': auth.user.role === 7 }"
  >
    <!--    <div v-if="showOverall && showPopup" class="tag-table">

                <div class="table-responsive">
                  <table class="table">
                    <tbody>
                    <tr>
                      <td> {{stats}} / {{sumOveral().ov_count}}</td>
                      <td>CR: {{((sumOveral().ov_count)/stats).toFixed(2) }}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>


            </div>-->
    <!--    <div class="btn-group btn-group-sm" role="group" aria-label="First group">-->
    <button
      type="button"
      class="btn btn-rf"
      @mouseenter="openSubWSecond('rf')"
      @mouseleave="closeSubWSecond('rf')"
    >
      <!--      @click="openSubW('regular', 'rf')"-->

      <!--      :class="{-->
      <!--      'btn-rf-agent': auth.user.role === 7,-->
      <!--      'greyed-out':-->
      <!--      selectedMainTab === 'bn' || greyOutTag('rf', selectedMainTab)-->
      <!--      }"-->
      <!--        {{ text }} <span>{{ kFormatter(stats) }}</span>-->
      <div
        v-tooltip="{
          placement: 'right',
          content:
            statsOv > 0 && stats > 0
              ? `
            ${getCR(statsOv, stats)}`
              : ''
        }"
      >
        <span v-if="statsOv === 0 && stats === 0">
          RF
        </span>
        <!--      <span v-else>{{ kFormatter(statsOv) + "/" + kFormatter(stats) }}</span>-->
        <span v-else>{{ kFormatter(stats) + "/" + kFormatter(statsOv) }}</span>
      </div>
      <!--      <span-->
      <!--        class="reset-btn"-->
      <!--        v-if="resetBtn.rf && resetButtons"-->
      <!--        @click.stop="closeResetBtn('rf')"-->
      <!--        ><i class="fas fa-times"></i-->
      <!--      ></span>-->
      <div class="bb-sub-menu" v-if="checkSubMenuMode('rf')">
        <div
          class="bb-sub-menu-ms"
          @click.stop="openMsW('rf')"
          v-tooltip="{ content: `Open multi-select` }"
        >
          <div class="rf-color bb-item">
            <i class="fas fa-bars"></i>
          </div>
          <div class="fake-column rf-color"></div>
        </div>
        <div
          class="bb-sub-menu-reset"
          @click.stop="closeResetBtnW('rf')"
          v-tooltip="{ content: `Reset` }"
        >
          <div class="rf-color bb-item">
            <i class="fas fa-times"></i>
          </div>
          <div class="fake-column rf-color"></div>
        </div>
      </div>
      <div class="bb-sub-menu" v-if="checkIfSecondView('rf')">
        <div
          v-if="checkNumbersOfCalendarsSelected() === 1"
          class="bb-sub-menu-ms"
          @click.stop="mergeAllDates('rf', 'regular', shortCutsToBlocks)"
          v-tooltip="{
            content: `Use the same selected dates with this new selection`
          }"
        >
          <!--          @click.stop="filterMultipleTags('regular', 'ld')"-->

          <div class="rf-color bb-item">
            <div class="first-circle-tot"></div>
            <div class="second-circle-tot"></div>
            <div class="fake-column-tot rf-color"></div>
          </div>
        </div>
        <div
          class="bb-sub-menu-reset"
          @click.stop="filterSingleTag('regular', 'rf')"
          v-tooltip="{ content: `Disregard previous selections` }"
        >
          <div class="rf-color bb-item">
            <div class="first-circle first-circle-right"></div>
            <div class="second-circle second-circle-right"></div>
          </div>
          <div class="fake-column rf-color"></div>
        </div>
        <div
          class="bb-sub-menu-ms"
          @click.stop="filterMultipleTags('regular', 'rf')"
          v-tooltip="{ content: `Productivity` }"
        >
          <div class="rf-color bb-item">
            <div class="first-circle"></div>
            <div class="second-circle "></div>
            <div class="fake-column rf-color"></div>
          </div>
        </div>
      </div>
      <div class="bb-title-wrapper upper-title">
        <span class="ref">Ref</span>
      </div>
      <div
        class="tags-dropdown"
        v-if="
          openTagDropdown &&
            mouseOver &&
            !checkSubMenuMode('rf') &&
            !checkIfSecondView('rf')
        "
      >
        <!--        <div class="tags-dropdown" v-if="false">-->
        <TagsDropdown
          :btnColors="btnColors"
          @presetTrigger="emitPresetTrigger"
        />
      </div>
    </button>

    <!--    </div>-->

    <!--    <a class="table-main-tag" :style="btnStyles" href="javascript:void(0);"-->
    <!--      >{{ text }} {{ kFormatter(stats) }}</a-->
    <!--    >-->
  </div>
</template>

<script>
import breadButtonsFunctionsUtil from "../../mixins/breadButtonsFunctionsUtil";
import { mapState } from "vuex";
import calendarCheck from "../../../../../../mixins/tags/calendarCheck";
import TagsDropdown from "./TagsDropdown.component";
import { Globals } from "../../../../../../global_constants/constants";

export default {
  name: "BreadcrumbButton",
  components: {
    TagsDropdown
  },

  props: {
    ifCalendarSelected: {
      type: Object
    },
    selectedMainTab: {
      type: String,
      required: true
    },
    secondActiveTagsArr: {
      type: Array
    },
    activeTags: {
      type: Array
    },
    resetButtons: {
      type: Boolean
    },
    variant: {
      type: String,
      required: false
    },
    bgColor: {
      type: String,
      required: true
    },
    txtColor: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false
    },
    stats: {
      type: Number,
      required: false
    },
    statsOv: {
      type: Number,
      required: false
    },
    showOverall: {
      type: Boolean,
      required: false
    },
    earRight: {
      type: Boolean,
      required: false,
      default: false
    },
    earLeft: {
      type: Boolean,
      required: false,
      default: false
    },
    switchPlaces: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  mounted() {},
  data() {
    return {
      calendarForPreset: "REF",
      mouseOver: false,
      btnColors: {
        backgroundColor: "#46acdc",
        color: "white"
      },
      openTagDropdown: false,
      showPopup: false,
      resetBtn: {
        rf: false
      }
    };
  },
  computed: {
    ...mapState("user", ["auth"]),

    ...mapState("clients", [
      "totalSumForCrumbBtn",
      "shortCutsToBlocks"
    ]),

    btnStyles() {
      return {
        "--bg-color": this.disabled ? "#546e7a" : this.bgColor,
        "--hover-on-disable": this.disabled ? "-3px" : "0px",
        "--font-weight": this.disabled ? "bold" : "normal",
        "--txt-color": this.txtColor,
        "--border-color": this.variant === "outlined" ? "#546e7a" : this.bgColor
      };
    }
  },
  mixins: [breadButtonsFunctionsUtil, calendarCheck],

  methods: {
    closePresetMenu() {
      this.openTagDropdown = false;
      this.mouseOver = false;
    },
    openPresetMenu() {
      this.mouseOver = true;
      setTimeout(() => {
        if (this.mouseOver) {
          this.openTagDropdown = true;
        }
      }, Globals.ux.section.top_tag_menu.cal_presets_speed);
    },
    emitPresetTrigger(preset) {
      if (preset !== "ALL") {
        this.triggerPreset(this.calendarForPreset, preset);
      }
      if (preset) {
        this.openSubW("regular", "rf");
      }
    },
    sumOveral() {
      return this.statsOverall.reduce((a, b) => ({
        ov_count: a.ov_count + b.ov_count
      }));
    },
    sumOveral2() {
      return this.statsOverall.reduce((a, b) => ({
        ov_count_2: a.ov_count_2 + b.ov_count_2
      }));
    },
    kFormatter: function(num) {
      if (num) {
        return Math.abs(num) > 999
          ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + "k"
          : Math.sign(num) * Math.abs(num);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
$btnColor: #46acdc;
$color: var(--bg-color);
$borderColor: var(--border-color);
$hoverColor: #546e7a;
$fontWeight: var(--font-weight);
.tag-wrapper {
  display: inline;
  position: relative;
}

#crumbs {
  position: relative;
  /*margin-right: 10px;*/
}

#crumbs a {
  display: block;
  float: left;
  height: 20px;
  width: 70px; //70px;
  line-height: 16pt;
  background: #af3131;
  padding: 0 3px 0 4px;
  border-color: $borderColor;
  position: relative;
  margin: 0 20px 0 0;
  text-align: center;
  text-decoration: none;
  color: var(--txt-color);
  font-size: 12px; //9pt;
  font-family: "Montserrat" !important;
  font-weight: 500;
  /*$fontWeight;*/
  /*border-bottom-left-radius: 5px;*/
  /*border-bottom-right-radius: 5px;*/
  /*border-top-left-radius: 5px;*/
  top: var(--hover-on-disable);
}

#crumbs a:hover {
  top: -3px;
}

.tag-table {
  position: absolute;
  bottom: 10px;
  right: 10px;
  z-index: 10001;
  width: max-content;
  background-color: #fff;
  border: solid 1px #90a4ae;
  border-radius: 5px;
  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
}

.table-responsive {
  margin-bottom: -18px;
  border-radius: 5px;
}

.dot-right {
  height: 26px;
  width: 26px;
  color: #009147;
  /*border-radius: 50%;*/
  bottom: 11px;
  right: -7px;
  position: absolute;
  font-weight: 500;
  font-size: 12px;
}

.dot-left {
  height: 26px;
  width: 26px;
  background-color: $color;
  border-radius: 50%;
  bottom: 8px;
  left: -8px;
  position: absolute;
  font-weight: 500;
  font-size: 12px;
}

.btn-rf {
  font-size: 10px;
  color: #ffffff;
  background-color: #46acdc;
  //border-color: $btnColor;
  transition: all 0.2s ease-in;
  width: 100%;
  border-radius: 5px !important;
  /*margin-right: 10px;*/
  position: relative;
}

.btn-rf {
  color: #ffffff;
  background-color: #46acdc;
  //border-color: $btnColor;
  outline: none;
  font-weight: 900;
  /*max-width: 61px;*/
}

.btn-rf-agent {
  /*max-width: 80px;*/
}

.btn-rf:hover,
.btn-rf:focus,
.btn-rf:active,
.btn-rf.active .open .dropdown-toggle.btn-rf {
  color: #ffffff;
  background-color: #46acdc;
  //border-color: $btnColor;
  outline: none;
  z-index: 0 !important;
}

.btn-rf:hover {
  outline: none;
  z-index: 1 !important;
  cursor: default;
}

.reset-btn {
  position: absolute;
  top: -8px;
  right: 0px;
  color: #333;
  transition: all 0.2s ease-in;
}

.reset-btn:hover {
  position: absolute;
  /*transform: scale(1.3);*/
  color: red;
}

.btn-rf:hover {
  transform: scale(1.1);
}

div.bb-title-wrapper {
  //position: absolute;
  color: white;
  font-size: 8px;
  width: 85%;
  top: 28px;
  left: 0px;
  text-align: center;
  transition: width 0.2s ease-in;
}

.crumbs-rf-agent {
  width: 105%;
}

.upper-title {
  text-transform: uppercase;
}

.bb-sub-menu-reset {
  /*margin-right: 10px;*/
}

/*<!--.bb-sub-menu-reset:after {-->*/
/*<!--  !*background-color: inherit;*!-->*/
/*<!--  content: "1";-->*/
/*<!--  position: absolute;-->*/
/*<!--  top: 20px;-->*/
/*<!--  height: 10px;-->*/
/*<!--  width: 8px;-->*/
/*<!--  color: inherit;-->*/
/*<!--  left: 6px;-->*/
/*<!--  color: $btnColor;-->*/
/*<!--}-->*/

/*<!--.bb-sub-menu-ms:after {-->*/
/*<!--  background-color: inherit;-->*/
/*<!--  content: "1";-->*/
/*<!--  position: absolute;-->*/
/*<!--  top: 20px;-->*/
/*<!--  height: 10px;-->*/
/*<!--  width: 8px;-->*/
/*<!--  color: inherit;-->*/
/*<!--  left: 48px;-->*/
/*<!--  color: $btnColor;-->*/
/*<!--}-->*/
.first-circle {
  background-color: white;
  height: 10px;
  width: 10px;
  position: absolute;
  border-radius: 50%;
  left: 2px;
  top: 8px;
}

.second-circle {
  background-color: white;
  height: 8px;
  width: 8px;
  position: absolute;
  border-radius: 50%;
  left: 8px;
  top: 3px;
}

.first-circle-right {
  /*left: 45px;*/
  background-color: white;
}

.second-circle-right {
  /*left: 50px;*/
  background-color: inherit;
  border: 1px solid white;
}

.bb-sub-menu {
  position: absolute;
  width: 100%;
  top: -26px;
  left: 0px;
  display: flex;
  justify-content: space-between;
  height: 30px;
  cursor: pointer;
}

.bb-sub-menu-reset,
.bb-sub-menu-ms {
  /*padding: 3px 5px;*/
  /*<!--background-color: $btnColor;-->*/
  border-radius: 4px;
  height: 30px;
  width: 20px;
}

.bb-item {
  height: 20px;
  width: 20px;
  border-radius: 5px;
  padding-top: 3px;
  position: relative;
}

.fake-column {
  width: 8px;
  height: 10px;
  margin-left: 6px;
}

div.second-circle + div.fake-column {
  margin-top: 14px;
}

.rf-color {
  background-color: $btnColor;
}

.greyed-out {
  opacity: 0.5;
  pointer-events: none;
}

.btn-group {
  z-index: 0 !important;
}

.first-circle-tot {
  background-color: inherit;
  height: 10px;
  width: 10px;
  position: absolute;
  border-radius: 50%;
  left: 2px;
  top: 8px;
  border: 1px solid white;
}

.second-circle-tot {
  border: 1px solid white;
  background-color: inherit;
  height: 8px;
  width: 8px;
  position: absolute;
  border-radius: 50%;
  left: 8px;
  top: 3px;
}

.fake-column-tot {
  width: 8px;
  /*height: 10px;*/
  height: 23px;
  margin-left: 6px;
}

.tags-dropdown {
  /*padding: 3px 5px;*/
  position: absolute;
  /*background-color: wheat;*/
  top: 38px;
  left: 0px;
  z-index: 1;
  border-radius: 5px;
  width: 100%;
}

.ref {
  padding-left: 5px;
}
</style>
